import { CollectionViewer } from '@angular/cdk/collections';
import { SiteState } from '@next/core-lib/site';
import { AgrDataSource } from '@next/core-lib/table-v2';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, debounceTime, Observable, shareReplay, Subject, takeUntil, tap } from 'rxjs';

import * as OverviewSelectors from '../../store/selectors';
import { OrderPlanOverviewV2 } from '../models';

export class OrderPlanOverviewDataSource extends AgrDataSource<OrderPlanOverviewV2> {
  public data$ = new BehaviorSubject<OrderPlanOverviewV2[]>([]);
  orderplanV2$ = this.store.pipe(select(OverviewSelectors.selectOrderplanV2Display));

  private readonly destroySubject$ = new Subject<boolean>();

  constructor(private store: Store<SiteState>) {
    super();
  }

  connect(_: CollectionViewer): Observable<OrderPlanOverviewV2[]> {
    this.orderplanV2$
      .pipe(
        debounceTime(100), // needed because the location selector is emitted mutiple times
        tap(() => this.loadingSubject.next(true)),
        takeUntil(this.destroySubject$),
        shareReplay(1),
      )
      .subscribe((result) => {
        this.loadingSubject.next(false);
        this.data$.next(result ?? []);
      });
    return this.data$;
  }

  disconnect(collectionViewer: CollectionViewer): void {
    super.disconnect(collectionViewer);
    this.destroySubject$.next(true);
    this.destroySubject$.complete();
  }
}
